import React from 'react';

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.hideModal = this.hideModal.bind(this);
    }

    componentDidMount() { }

    hideModal(e){
        let currentElem = e.currentTarget;
    }

    render() {
        let member = this.props.member;
        let _this = this;
        return (
            <div className="modal-people" style={{ backgroundColor: member.modal_color, color: '#ffffff'}}>
                <div className="main-container posiR">
                    <a href="javascript:" className="btn-closemenu toggle-ppl" onClick={_this.hideModal}></a>
                    <div className="grid pt-0 pl-0 pr-0 grid-one">
                        <h2 className="title-lg">People</h2>
                        <div className="">
                            <h4 className="title-lg mt-0">{member.name} <span className="d-block">{member.designation}</span></h4>
                            <h6>{member.qualification}</h6>
                        </div>
                    </div>
                    <div className="grid pl-0 pr-0">
                        <figure>
                            <img src={member.image.url} alt={member.name} title={member.name} />
                        </figure>
                        <article>
                            <div className="desc mb-0" dangerouslySetInnerHTML={{__html: member.details }} />
                        </article>
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Practice/Modal.js